import {
  REQUEST_ALL_SKILLS,
  RECEIVE_ALL_SKILLS,
  REQUEST_SKILL,
  RECEIVE_SKILL,
  REQUEST_ACTIVITY_SKILLS,
  RECEIVE_ACTIVITY_SKILLS,
  REQUEST_ALL_SKILL_GROUPS,
  RECEIVE_ALL_SKILL_GROUPS,
} from "../constants/actionTypes";
import { getBody, displayError } from "./helpers";
import { getBackendUrl } from "../env";

const requestAllSkills = {
  type: REQUEST_ALL_SKILLS,
};

export const receiveAllSkills = (json) => ({
  type: RECEIVE_ALL_SKILLS,
  allSkills: json,
});

const requestSkill = {
  type: REQUEST_SKILL,
};

export const receiveSkill = (json) => ({
  type: RECEIVE_SKILL,
  skill: json,
});

const requestActivitySkills = {
  type: REQUEST_ACTIVITY_SKILLS,
};

const receiveActivitySkills = (json) => ({
  type: RECEIVE_ACTIVITY_SKILLS,
  activitySkills: json,
});

const requestAllSkillGroups = {
  type: REQUEST_ALL_SKILL_GROUPS,
};

export const receiveAllSkillGroups = (json) => ({
  type: RECEIVE_ALL_SKILL_GROUPS,
  allSkillGroups: json,
});

export const getAllSkills = () => (dispatch) => {
  dispatch(requestAllSkills);
  return fetch(`${getBackendUrl()}/api/v1/data/skills`, {
    headers: { "Content-Type": "application/json" },
  })
    .then(getBody)
    .then((json) => {
      dispatch(receiveAllSkills(json));
    })
    .catch((err) => {
      dispatch(displayError(err));
    });
};

export const getSkill = (skillName) => (dispatch) => {
  dispatch(requestSkill);
  return fetch(`${getBackendUrl()}/api/v1/data/skill/` + skillName, {
    headers: { "Content-Type": "application/json" },
  })
    .then(getBody)
    .then((json) => {
      dispatch(receiveSkill(json));
    })
    .catch((err) => {
      dispatch(displayError(err));
    });
};

export const getActivitySkills = (activityId) => (dispatch) => {
  dispatch(requestActivitySkills);
  return fetch(
    `${getBackendUrl()}/api/v1/data/skills/activities?activityName=` +
      activityId,
    { headers: { "Content-Type": "application/json" } }
  )
    .then(getBody)
    .then((json) => {
      dispatch(receiveActivitySkills(json));
    })
    .catch((err) => {
      dispatch(displayError(err));
    });
};

export const getAllSkillGroups = () => (dispatch) => {
  dispatch(requestAllSkillGroups);
  return fetch(`${getBackendUrl()}/api/v1/data/skillgroups`, {
    headers: { "Content-Type": "application/json" },
  })
    .then(getBody)
    .then((json) => {
      dispatch(receiveAllSkillGroups(json));
    })
    .catch((err) => {
      dispatch(displayError(err));
    });
};



// WEBPACK FOOTER //
// ./src/actions/skills.js